import { grayBorder } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors';
import { gridGutterHalf, fontSize12 } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'

export const item = `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${gridGutterHalf}px;    

    > div {
        flex: 80px 0 0;
    }

    label {
        flex: 1 0 auto;
    }
`

export const helper = `
    display: block;
    font-weight: 300;
    font-size: ${fontSize12};
`

export const passengers = `
    border-bottom: 1px solid ${grayBorder};
    padding-bottom: ${gridGutterHalf}px;
    margin-bottom: ${gridGutterHalf}px;
`